export default "__VITE_ASSET__DaH_5Dgb__"